import React from 'react';
import rec from './rec.css'
import {useState} from 'react';
import Tilt from 'react-tilt'
const Recipes = (props) =>{
    const [selectedId, setSelectedId] = useState(null)
    return(
        <div  className="container">
            <h1>{props.name}</h1>
            <p>cal : {props.cal}</p>
            <p>{props.tag ? props.tag : "no tag"}</p>
            <img src= {props.image} alt="khana ka photo"></img>
            <ul>
            {props.ingredients.map(ing=>(
                <li>{ing.text}</li>
            ))}
            </ul>
        </div>
    )
}
export default Recipes;